import State, { PlacingOderStatus } from './State';

const order: State = {
    articlesEstimations: {},
    orderFilters: [],
    searchQuery: '',
    orderDetails: null,
    orderedSku: {},
    deliveryFee: 0,
    liabilityMet: 0,
    placingOrderStatus: PlacingOderStatus.Null,
    orderedCheckout: { total: 0, quantity: 0 },
    orderedStock: { total: 0, quantity: 0 },
    estimated: { total: 0, quantity: 0 }
};

export default order;



// WEBPACK FOOTER //
// ./src/application/order/initialState.ts